<template>
  <svg
    aria-hidden="true"
    focusable="false"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 321.188 321.188"
  >
    <polygon points="61.129,0 61.129,321.188 160.585,250.657 260.059,321.188 260.059,0 " />
  </svg>
</template>
<script>
export default {
  name: "M4FlagSvg"
};
</script>
